var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":"required","vid":"pageKey"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-select',{attrs:{"label":"Page*","items":_vm.pages.map(function (x) { return ({
        text: x.displayName,
        value: x.key
      }); }),"disabled":_vm.locked,"outlined":"","error-messages":errors},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }